import { Drawer } from 'antd'
import React from 'react'

function CustomDrawer({open, title, children, ...restProps}) {
  return (
    <Drawer 
      open={open} 
      title={title} 
      contentWrapperStyle={{margin: 20}}
      closable={false}
      {...restProps}
    >
      {children}
    </Drawer>
  )
}




export default CustomDrawer